import React from "react";
import { useStore } from "mcmap-lib/src/stores/store";

const setDetailsSelection = useStore.getState().setDetailsSelection;

const showDetailsButtonColumn = {
  id: "showDetails",
  header: () => <></>,
  size: 110,
  cell: ({ row }) => (
    <button
      onClick={() => setDetailsSelection(row.original)}
      className="btn-athena btn-xs h-auto"
    >
      Show Details
    </button>
  ),
};

export const addressColumns = [
  {
    accessorKey: "address",
    header: "Address",
    size: 300,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "latitude",
    header: "Latitude",
    size: 120,
    cell: (info) => {
      const value = info.getValue();
      return value ? parseFloat(value).toFixed(7) : "";
    },
  },
  {
    accessorKey: "longitude",
    header: "Longitude",
    size: 120,
    cell: (info) => {
      const value = info.getValue();
      return value ? parseFloat(value).toFixed(7) : "";
    },
  },
];

export const subdivisionColumns = [
  {
    accessorKey: "NAME",
    header: "Name",
    size: 300,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "SUBCODE",
    size: 100,
    header: "Subdivision Code",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "PAGES",
    size: 80,
    header: "Pages",
    cell: (info) => info.getValue(),
  },
];

export const salesColumns = [
  showDetailsButtonColumn,
  {
    id: "parcelNumber",
    accessorKey: "ParcelNumber",
    header: "ParcelNumber",
    size: 100,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "ParcelNumber",
    id: "tapestry",
    header: "Tapestry",
    size: 100,
    cell: (info) => {
      const val = info.getValue();
      return (
        <a
          className="text-blue-500 hover:underline"
          target="_blank"
          rel="noreferrer noopener"
          href={`https://tapestry.fidlar.com/Tapestry2/LinkToTapestry.aspx?County=McHenry&State=IL&ParcelNum=${val}`}
        >
          Click Here
        </a>
      );
    },
  },
  {
    accessorKey: "DateOfSale",
    size: 100,
    header: "Sale Date",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Amount",
    size: 80,
    header: "Sale Amount",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Township",
    size: 100,
    header: "Township",
    cell: (info) => info.getValue(),
  },
];

export const taxParcelColumns = [
  showDetailsButtonColumn,
  {
    accessorKey: "ParcelNumber",
    size: 120,
    header: "Parcel Number",
    cell: (info) => info.getValue(),
  },
  {
    id: "Tapestry",
    size: 90,
    sortable: false,
    accessorKey: "ParcelNumber",
    header: "Tapestry",
    cell: (info) => {
      const val = info.getValue();
      return (
        <a
          className="text-blue-500 hover:underline"
          target="_blank"
          rel="noreferrer noopener"
          href={`https://tapestry.fidlar.com/Tapestry2/LinkToTapestry.aspx?County=McHenry&State=IL&ParcelNum=${val}`}
        >
          Click Here
        </a>
      );
    },
  },
  {
    id: "township",
    size: 140,
    accessorKey: "Township",
    cell: (info) => info.getValue(),
    header: "Township",
  },
  {
    id: "TaxCode",
    size: 85,
    accessorKey: "TaxCode",
    cell: (info) => info.getValue(),
    header: "Tax Code",
  },
  {
    id: "TaxStatus",
    accessorKey: "TaxStatus",
    cell: (info) => info.getValue(),
    header: "Tax Status",
    size: 60,
  },
  {
    id: "PropertyClass",
    accessorKey: "PropertyClass",
    cell: (info) => info.getValue(),
    header: "Property Class",
    size: 150,
  },
  {
    id: "Owner",
    accessorKey: "Owner",
    cell: (info) => info.getValue(),
    header: "Owner",
    size: 240,
  },
  {
    id: "MailToAddress1",
    accessorKey: "MailToAddress1",
    size: 240,
    cell: (info) => info.getValue(),
    header: "Mail To Address",
  },

  {
    id: "SiteAddress",
    accessorKey: "SiteAddress",
    size: 240,
    cell: (info) => info.getValue(),
    header: "Site Address",
  },
  {
    id: "Unit",
    accessorKey: "Unit",
    cell: (info) => info.getValue(),
    header: "Unit",
  },
  {
    id: "SiteCity",
    accessorKey: "SiteCity",
    cell: (info) => info.getValue(),
    header: "Site Address City",
  },
  {
    id: "ParcelArea",
    accessorKey: "ParcelArea",
    cell: (info) => {
      const value = info.getValue();
      return value ? `${Math.round(value).toLocaleString()} sqft` : "";
    },
    header: "Parcel Area",
  },
];
